import { PreloadedQuery } from 'react-relay';
import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectAccessPermissionsSettingsAggQuery, {
	type ProjectAccessPermissionsSettingsAggQuery as ProjectAccessPermissionsSettingsAggQueryType,
} from '../../components/ProjectAccessPermissionsSettings/__generated__/ProjectAccessPermissionsSettingsAggQuery.graphql';

export const projectAccessPermissionsSettingsResource: RouteResource<
	PreloadedQuery<ProjectAccessPermissionsSettingsAggQueryType, Record<string, unknown>>
> = createRelayResource<ProjectAccessPermissionsSettingsAggQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const variables: VariablesOf<ProjectAccessPermissionsSettingsAggQueryType> = {
			containerId: context.collabContext?.contextId ?? '',
			isM3GroupPermsEnabled: fg('townsquare_m3_group_permissions'),
			isDefaultAccessLevelEnabled: fg('atlas_enable_projects_default_access_toggle'),
		};

		return {
			query: ProjectAccessPermissionsSettingsAggQuery,
			variables,
			environment: getAggRelayEnvironment(),
		};
	},
});
